import { Button } from '@/components/ui/button';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { motion } from 'framer-motion';
import ConfirmationDialog from './ConfirmationDialog';
import { useState } from 'react';
import UseDarkMode from './UseDarkMode';
import { ChevronDown, Moon, Sun } from 'lucide-react';
import { useAuth } from '@/Services/AuthContext';
import { useNavigate } from 'react-router-dom';

function Navbar() {
	const [showLogoutDialog, setShowLogoutDialog] = useState(false);
	const [isDarkMode, toggleDarkMode] = UseDarkMode();
	const { user, isAuthenticated, loading, login, logout } = useAuth();

	const navigate = useNavigate();


	return (
		<nav className='from-accent-light to-accent bg-gradient-to-tl w-full h-16 shadow-lg border-b border-accent fixed top-0 left-0 right-0 z-30'>
			<div className='container mx-auto relative flex justify-between h-full items-center px-5 sm:px-20'>
				<img
					src="/logo_sm.png"
					alt="Logo"
					initial={{ scale: 0, y: -50 }}
					animate={{
						scale: 1,
						y: 0
					}}
					// transition={{
					// 	type: "spring",
					// 	stiffness: 400,
					// 	damping: 10,
					// 	mass: 1,
					// 	bounce: 0.5
					// }}
					className="h-12"
				/>
				<div className='flex gap-2'>
					<Button onClick={() => { toggleDarkMode(!isDarkMode) }} className="font-bold" variant="glass" size="icon" aria-label="Submit">
						{isDarkMode ? (<Moon size={28} strokeWidth={3} />) : (<Sun size={28} strokeWidth={3} />)}
					</Button>
					<DropdownMenu>
						<DropdownMenuTrigger asChild>
							<Button className="" variant="glass" aria-label="Submit">
								<span className='uppercase'>{user.full_name}</span>
								<ChevronDown size={28} strokeWidth={3} />
							</Button>
						</DropdownMenuTrigger>
						<DropdownMenuContent>
							<DropdownMenuLabel>My Account</DropdownMenuLabel>
							<DropdownMenuSeparator />
							<DropdownMenuItem onClick={() => navigate('/profile')} >Profile</DropdownMenuItem>
							<DropdownMenuItem onClick={() => navigate('/history')} >Visits</DropdownMenuItem>
							<DropdownMenuItem onClick={() => navigate('/booking/history')} >Bookings</DropdownMenuItem>
							<DropdownMenuItem onClick={() => navigate('/funpass')} >Fun Pass</DropdownMenuItem>
							<DropdownMenuSeparator />
							<DropdownMenuItem onClick={() => setShowLogoutDialog(true)}>Log out</DropdownMenuItem>
						</DropdownMenuContent>
					</DropdownMenu>
				</div>
			</div>
			<ConfirmationDialog
				title='Logging out of your account'
				message='Confirm logging out of your account from this device?'
				onConfirm={logout}
				open={showLogoutDialog}
				onOpenChange={setShowLogoutDialog}
			/>
		</nav>
	);
}
export default Navbar;